import { Label } from "layout/typography/Label";
import { InputText } from "primereact/inputtext";
import { Controller, useFormContext } from "react-hook-form";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

interface IInsuranceNameProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
}

export function InsuranceName({ linkConfig }: IInsuranceNameProps) {
  const { control } = useFormContext();

  // Gated by the link the same way the provider and account number fields are
  if (!linkConfig?.showInsuranceName) {
    return null;
  }

  return (
    <div className="field flex flex-column col-12 md:col-6">
      <Label htmlFor="insuranceName">Insurance Name</Label>

      <Controller
        name="insuranceName"
        control={control}
        render={({ field: { onChange, value } }) => (
          <InputText
            id="insuranceName"
            autoComplete="off"
            value={value || ""}
            placeholder="Insurance Name"
            aria-labelledby="insuranceName"
            onChange={onChange}
          />
        )}
      />
    </div>
  );
}
